export default (val) => {
  if (!val) {
    return '';
  }

  const value = val.toString();
  return value.toUpperCase();
};



// WEBPACK FOOTER //
// ./src/filter/uppercase.js